module.exports = __webpack_public_path__ + "img/9788970125268.0d600bb9.jpg";